"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var md5_1 = __importDefault(require("crypto-js/md5"));
var enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
var utils_1 = require("./utils");
var EventEmitter_1 = __importDefault(require("./base/EventEmitter"));
var const_1 = require("./const");
var NOOP = function () { };
var pluginIndex = 0;
var K18nUtils = /** @class */ (function (_super) {
    __extends(K18nUtils, _super);
    function K18nUtils(options) {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        _this.plugins = {};
        _this.messagesMeta = {};
        /**
         * @memberof K18nUtils
         * @description 将多语言导出的格式转化成对象格式
         */
        _this.baseTransformMessages = function (messages) {
            var _a = messages || {}, _b = _a.language, language = _b === void 0 ? [] : _b, _c = _a.textList, textList = _c === void 0 ? [] : _c;
            return language.reduce(function (pkg, lang, index) {
                var textOfLang = {};
                textList.forEach(function (item) {
                    var _a = item.key, key = _a === void 0 ? '' : _a, _b = item.hash, hash = _b === void 0 ? '' : _b, _c = item.text, text = _c === void 0 ? [] : _c;
                    textOfLang[key] = text[index];
                    textOfLang[hash] = text[index];
                });
                pkg[lang] = __assign({}, textOfLang);
                return pkg;
            }, {});
        };
        _this.options = options;
        _this.locale = options.locale || (0, utils_1.getDefaultLocale)();
        _this.fallbackLocale = options.fallbackLocale || const_1.DEFAULT_FALLBACL_LOCALE;
        options.messages = (_a = options.messages) !== null && _a !== void 0 ? _a : {};
        _this._messages = _this.processMessages(options.messages);
        _this.extractMeta(options.messages);
        _this.formatter = options.formatter || [];
        // 初始化 plugins
        if (Array.isArray(options.plugins)) {
            options.plugins.forEach(function (plugin) {
                if (typeof plugin === 'object' && typeof plugin.apply === 'function') {
                    _this.use(plugin);
                }
            });
        }
        // 初始化 events
        if (options.events) {
            Object.keys(options.events).forEach(function (evt) {
                var _a;
                var callback = ((_a = options.events) === null || _a === void 0 ? void 0 : _a[evt]) || NOOP;
                _this.on(evt, callback);
            });
        }
        // 计算 rtl，并执行 callback
        _this.handleRtl();
        return _this;
    }
    Object.defineProperty(K18nUtils.prototype, "messages", {
        get: function () {
            return this._messages;
        },
        set: function (value) {
            this._messages = value;
            this.emit('MESSAGES_CHANGED', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(K18nUtils.prototype, "isRtl", {
        get: function () {
            return this.getIsRtl();
        },
        enumerable: false,
        configurable: true
    });
    K18nUtils.prototype.handleRtl = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if ((_a = this.options.rtl) === null || _a === void 0 ? void 0 : _a.watcher) {
            if (this.isRtl && ((_c = (_b = this.options.rtl) === null || _b === void 0 ? void 0 : _b.watcher) === null || _c === void 0 ? void 0 : _c.on)) {
                (_e = (_d = this.options.rtl) === null || _d === void 0 ? void 0 : _d.watcher) === null || _e === void 0 ? void 0 : _e.on();
                return;
            }
            if (!this.isRtl && ((_g = (_f = this.options.rtl) === null || _f === void 0 ? void 0 : _f.watcher) === null || _g === void 0 ? void 0 : _g.off)) {
                (_j = (_h = this.options.rtl) === null || _h === void 0 ? void 0 : _h.watcher) === null || _j === void 0 ? void 0 : _j.off();
                return;
            }
        }
    };
    K18nUtils.prototype.getIsRtl = function () {
        var _a, _b, _c, _d;
        if ((_a = this.options.rtl) === null || _a === void 0 ? void 0 : _a.handler) {
            return (_b = this.options.rtl) === null || _b === void 0 ? void 0 : _b.handler(this.locale);
        }
        if ((_c = this.options.rtl) === null || _c === void 0 ? void 0 : _c.codes) {
            var codes = ((_d = this.options.rtl) === null || _d === void 0 ? void 0 : _d.codes) || [];
            return __spreadArray(__spreadArray([], __read(const_1.DEFAULT_RTL_CODES), false), __read(codes), false).indexOf(this.locale) > -1;
        }
        return const_1.DEFAULT_RTL_CODES.indexOf(this.locale) > -1;
    };
    K18nUtils.prototype.extractMeta = function (messages) {
        if (Array.isArray(messages)) {
            messages = messages[0]; // 理论上元信息是一样的，取第一个没啥问题。
        }
        if (messages) {
            this.messagesMeta = {
                config: messages.config,
                timestamp: messages.timestamp
            };
        }
    };
    K18nUtils.prototype.use = function (pluginInstance) {
        if (pluginInstance) {
            var key = pluginInstance.key || pluginInstance.constructor && pluginInstance.constructor.key || "plugin_auto_key_".concat(pluginIndex++);
            if (typeof pluginInstance.apply === 'function'
                && (!pluginInstance.k18n || pluginInstance.k18n !== this)) {
                pluginInstance.apply(this);
            }
            this.plugins[key] = pluginInstance;
        }
    };
    K18nUtils.prototype.genHash = function (params) {
        var _a = params.text, text = _a === void 0 ? '' : _a, _b = params.desc, desc = _b === void 0 ? '' : _b;
        var normalized = "<<text:>>".concat(text, "<<desc:>>").concat(desc);
        return (0, md5_1.default)(normalized).toString(enc_base64_1.default);
    };
    K18nUtils.prototype.baseMergeMessagesObj = function (messagesList) {
        var merge = function (source, target) {
            // 后面覆盖前面的
            var lauguageCodes = __spreadArray(__spreadArray([], __read(Object.keys(source)), false), __read(Object.keys(target)), false);
            var merged = {};
            lauguageCodes.forEach(function (l) {
                merged[l] = Object.assign(source[l] || {}, target[l] || {});
            });
            return merged;
        };
        return messagesList.reduce(merge, {});
    };
    K18nUtils.prototype.processMessages = function (messages) {
        var _this = this;
        if (!Array.isArray(messages)) {
            messages = [messages];
        }
        var messagesList = messages.map(function (m) { return _this.baseTransformMessages(m); });
        return this.baseMergeMessagesObj(messagesList);
    };
    K18nUtils.prototype.addMessages = function (messages) {
        var transformed = this.baseTransformMessages(__assign({}, messages));
        this.messages = this.baseMergeMessagesObj([this.messages, transformed]);
    };
    K18nUtils.prototype.changeLocale = function (locale) {
        this.locale = locale;
        this.emit('LOCALE_CHANGED', locale);
        this.handleRtl();
    };
    K18nUtils.prototype.changeFallbackLocale = function (locale) {
        this.fallbackLocale = locale;
        this.emit('FALLBACK_LOCALE_CHANGED', locale);
    };
    K18nUtils.prototype.getLangByKeyOrText = function (key, params) {
        if (!key)
            return '';
        var messages = this.messages;
        var currentLocale = params.locale || this.locale;
        var currentFallbackLocale = params.fallbackLocale || this.fallbackLocale;
        var originText = messages[currentLocale] && messages[currentLocale][key];
        // 再查 fallback 的 locale
        if (!originText) {
            originText = this.messages[currentFallbackLocale] && this.messages[currentFallbackLocale][key];
        }
        if (!originText) {
            return '';
        }
        else if (params.params) {
            return this.injectParams(originText, params.params);
        }
        else {
            return originText;
        }
    };
    K18nUtils.prototype.injectParams = function (text, params) {
        Object.keys(params || {}).forEach(function (prop) {
            // 兼容 ${} 模板
            var reg1 = new RegExp("\\$\\{".concat(prop, "\\}"), 'g');
            // 兼容 {}$ 模板 rtl
            var reg2 = new RegExp("\\{".concat(prop, "\\}\\$"), 'g');
            // 兼容 {}
            var reg3 = new RegExp("\\{".concat(prop, "\\}"), 'g');
            text = text
                .replace(reg1, "".concat(params[prop]))
                .replace(reg2, "".concat(params[prop]))
                .replace(reg3, "".concat(params[prop]));
        });
        return text;
    };
    K18nUtils.prototype.postFormatter = function (text) {
        var _a = this.formatter, formatter = _a === void 0 ? [] : _a;
        var result = text;
        formatter.forEach(function (f) {
            if (typeof f.interpolate === 'function') {
                result = f.interpolate(result);
                if (result === '' || result === undefined) {
                    console.warn("[k18n formatter warning]: ".concat(f.name || 'unknown formatter', " formatter \u7684\u8FD4\u56DE\u503C\u4E3A\u7A7A\uFF0C \u8BF7\u68C0\u67E5\u662F\u5426\u6709\u9519\u8BEF"));
                    result = '';
                }
            }
        });
        return result;
    };
    K18nUtils.prototype.getText = function (key, params) {
        params = (params || {});
        if (typeof key === 'string') {
            // 第一个参数是 string, 把它当做中文文案
            params = Object.assign(params, { text: key });
        }
        else {
            // 第一个参数是对象，就用这个对象
            params = key;
        }
        var id = params.id;
        var lang = '';
        // 1. 优先用 id 查
        if (!lang) {
            lang = this.getLangByKeyOrText(id, params);
        }
        // 2. 再用 hash 查
        if (!lang) {
            var hash = this.genHash(params);
            lang = this.getLangByKeyOrText(hash, params);
        }
        // 3. 再用 text 查
        if (!lang) {
            lang = this.getLangByKeyOrText(params.text, params);
        }
        // 还没查到，开始处理异常，console.error 或者上报
        if (!lang) {
            console.warn("\u901A\u8FC7 key: ".concat(params.id || '', ", text: ").concat(params.text || '', ", desc: ").concat(params.desc || '', " \u65E0\u6CD5\u67E5\u8BE2\u5230\u6587\u6848\uFF0C\u8BF7\u68C0\u67E5"));
            return this.injectParams(params.id || params.text || '', params.params || {});
        }
        return this.postFormatter(lang);
    };
    return K18nUtils;
}(EventEmitter_1.default));
exports.default = K18nUtils;
